import PropTypes from 'prop-types';

const FooterInfo = ({ copyright }) => (
  <div className="footer__row footer__row--base">
    <div className="footer__wrapper footer__wrapper--base">
      <p>{copyright}</p>
    </div>
  </div>
);

FooterInfo.propTypes = {
  copyright: PropTypes.string.isRequired
};

export default FooterInfo;
